// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"hdd3W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateRangePicker", ()=>DateRangePicker);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _dateField = require("./DateField");
var _form = require("./Form");
var _popover = require("./Popover");
var _rangeCalendar = require("./RangeCalendar");
var _lucideReact = require("lucide-react");
var _dateRangePickerCss = require("./DateRangePicker.css");
'use client';
function DateRangePicker({ label, description, errorMessage, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.DateRangePicker), {
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Label), {
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Group), {
                className: "react-aria-Group inset",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateField.DateInput), {
                        slot: "start",
                        children: (segment)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateField.DateSegment), {
                                segment: segment
                            })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        "aria-hidden": "true",
                        children: "\u2013"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateField.DateInput), {
                        slot: "end",
                        children: (segment)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateField.DateSegment), {
                                segment: segment
                            })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.FieldButton), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronDown), {
                            size: 16
                        })
                    })
                ]
            }),
            description && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Description), {
                children: description
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.FieldError), {
                children: errorMessage
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popover.Popover), {
                hideArrow: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rangeCalendar.RangeCalendar), {})
            })
        ]
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["DateRangePicker","59rph"],["Group","6UspO"]],"./DateField":"1mJlu","./Form":"6qejZ","./Popover":"cvyKh","./RangeCalendar":"23d99","lucide-react":[["ChevronDown","kWVt3","default"]],"./DateRangePicker.css":"ajx18","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1mJlu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateField", ()=>DateField);
parcelHelpers.export(exports, "DateSegment", ()=>DateSegment);
parcelHelpers.export(exports, "DateInput", ()=>DateInput);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _form = require("./Form");
var _dateFieldCss = require("./DateField.css");
'use client';
function DateField({ label, description, errorMessage, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.DateField), {
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Label), {
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(DateInput, {
                children: (segment)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(DateSegment, {
                        segment: segment
                    })
            }),
            description && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Description), {
                children: description
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.FieldError), {
                children: errorMessage
            })
        ]
    });
}
function DateSegment(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.DateSegment), {
        ...props
    });
}
function DateInput(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.DateInput), {
        ...props,
        className: "react-aria-DateInput inset"
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":"5wv9P","./Form":"6qejZ","./DateField.css":"g2XHy","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6qejZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Form", ()=>Form);
parcelHelpers.export(exports, "Label", ()=>Label);
parcelHelpers.export(exports, "FieldError", ()=>FieldError);
parcelHelpers.export(exports, "Description", ()=>Description);
parcelHelpers.export(exports, "FieldButton", ()=>FieldButton);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _formCss = require("./Form.css");
var _content = require("./Content");
'use client';
function Form(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Form), {
        ...props
    });
}
function Label(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Label), {
        ...props
    });
}
function FieldError(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.FieldError), {
        ...props
    });
}
function Description(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
        slot: "description",
        className: "field-description",
        ...props
    });
}
function FieldButton(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
        ...props,
        className: "field-Button"
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["Button","9G5XO"],["FieldError","algyu"],["Form","g7RKA"],["Label","fjKq6"]],"./Form.css":"7sxTy","./Content":"jYtLe","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7sxTy":[function() {},{}],"jYtLe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Heading", ()=>Heading);
parcelHelpers.export(exports, "Text", ()=>Text);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _contentCss = require("./Content.css");
function Heading(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Heading), {
        ...props
    });
}
function Text(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
        ...props
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["Heading","2f4nH"],["Text","jt9fm"]],"./Content.css":"kvyv3","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kvyv3":[function() {},{}],"g2XHy":[function() {},{}],"cvyKh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Popover", ()=>Popover);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _popoverCss = require("./Popover.css");
'use client';
function Popover({ children, hideArrow, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Popover), {
        ...props,
        className: (0, _clsxDefault.default)("react-aria-Popover", props.className),
        children: ({ trigger })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    !hideArrow && trigger !== 'MenuTrigger' && trigger !== 'SubmenuTrigger' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.OverlayArrow), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                            width: 12,
                            height: 12,
                            viewBox: "0 0 12 12",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M0 0 L6 6 L12 0"
                            })
                        })
                    }),
                    children
                ]
            })
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["OverlayArrow","kMtnS"],["Popover","l4JC0"]],"clsx":"4P1lK","./Popover.css":"6SWas","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6SWas":[function() {},{}],"23d99":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RangeCalendar", ()=>RangeCalendar);
parcelHelpers.export(exports, "CalendarGrid", ()=>(0, _calendar.CalendarGrid));
parcelHelpers.export(exports, "CalendarCell", ()=>CalendarCell);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _button = require("./Button");
var _lucideReact = require("lucide-react");
var _calendar = require("./Calendar");
var _rangeCalendarCss = require("./RangeCalendar.css");
'use client';
function RangeCalendar({ errorMessage, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.RangeCalendar), {
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("header", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                        slot: "previous",
                        variant: "quiet",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronLeft), {
                            size: 18
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Heading), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                        slot: "next",
                        variant: "quiet",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronRight), {
                            size: 18
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendar.CalendarGrid), {
                children: (date)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(CalendarCell, {
                        date: date
                    })
            }),
            errorMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
                slot: "errorMessage",
                children: errorMessage
            })
        ]
    });
}
function CalendarCell(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.CalendarCell), {
        ...props,
        children: (0, _reactAriaComponents.composeRenderProps)(props.children, (children, { defaultChildren, isHovered, isPressed, isSelectionStart, isSelectionEnd, isDisabled })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "button-base",
                "data-variant": "quiet",
                "data-hovered": isHovered || undefined,
                "data-pressed": isPressed || undefined,
                "data-selected": isSelectionStart || isSelectionEnd || undefined,
                "data-disabled": isDisabled || undefined,
                children: children || defaultChildren
            }))
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["CalendarCell","2DleA"],["RangeCalendar","2DleA"],["composeRenderProps","bA6Cz"],["Heading","2f4nH"],["Text","jt9fm"]],"./Button":"36nan","lucide-react":[["ChevronLeft","6gHLa","default"],["ChevronRight","elAlB","default"]],"./Calendar":"iKsWV","./RangeCalendar.css":"bosH7","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"36nan":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Button", ()=>Button);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _progressCircle = require("./ProgressCircle");
var _buttonCss = require("./Button.css");
'use client';
function Button(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
        ...props,
        className: "react-aria-Button button-base",
        "data-variant": props.variant || 'primary',
        children: (0, _reactAriaComponents.composeRenderProps)(props.children, (children, { isPending })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    !isPending && children,
                    isPending && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressCircle.ProgressCircle), {
                        "aria-label": "Saving...",
                        isIndeterminate: true
                    })
                ]
            }))
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["Button","9G5XO"],["composeRenderProps","bA6Cz"]],"./ProgressCircle":"c08Ay","./Button.css":"maD70","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"c08Ay":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProgressCircle", ()=>ProgressCircle);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
'use client';
function ProgressCircle(props) {
    // SVG strokes are centered, so subtract half the stroke width from the radius to create an inner stroke.
    let strokeWidth = 4;
    let radius = `calc(50% - ${strokeWidth / 2}px)`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ProgressBar), {
        ...props,
        style: (0, _reactAriaComponents.composeRenderProps)(props.style, (style)=>({
                ...style,
                width: props.size || 16,
                height: props.size || 16
            })),
        children: ({ percentage, isIndeterminate })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                    fill: "none",
                    width: "100%",
                    height: "100%",
                    viewBox: "0 0 32 32",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: "50%",
                            cy: "50%",
                            r: radius,
                            stroke: "var(--highlight-pressed)",
                            strokeWidth: strokeWidth
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: "50%",
                            cy: "50%",
                            r: radius,
                            stroke: "var(--highlight-background)",
                            strokeWidth: strokeWidth,
                            // Normalize the path length to 100 so we can easily set stroke-dashoffset to a percentage.
                            pathLength: "100",
                            // Add extra gap between dashes so 0% works in Chrome.
                            strokeDasharray: "100 200",
                            strokeDashoffset: 100 - (isIndeterminate || percentage == null ? 25 : percentage),
                            strokeLinecap: "round",
                            style: {
                                rotate: '-90deg',
                                transformOrigin: 'center center'
                            },
                            children: isIndeterminate && /*#__PURE__*/ (0, _jsxRuntime.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                dur: "0.75s",
                                values: "0;360",
                                repeatCount: "indefinite"
                            })
                        })
                    ]
                })
            })
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["composeRenderProps","bA6Cz"],["ProgressBar","kPGON"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"maD70":[function() {},{}],"6gHLa":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>ChevronLeft);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "m15 18-6-6 6-6",
            key: "1wnfg3"
        }
    ]
];
const ChevronLeft = (0, _createLucideIconJsDefault.default)("chevron-left", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gsSty":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createLucideIcon);
var _react = require("react");
var _utilsJs = require("./shared/src/utils.js");
var _iconJs = require("./Icon.js");
var _iconJsDefault = parcelHelpers.interopDefault(_iconJs);
const createLucideIcon = (iconName, iconNode)=>{
    const Component = (0, _react.forwardRef)(({ className, ...props }, ref)=>(0, _react.createElement)((0, _iconJsDefault.default), {
            ref,
            iconNode,
            className: (0, _utilsJs.mergeClasses)(`lucide-${(0, _utilsJs.toKebabCase)((0, _utilsJs.toPascalCase)(iconName))}`, `lucide-${iconName}`, className),
            ...props
        }));
    Component.displayName = (0, _utilsJs.toPascalCase)(iconName);
    return Component;
};

},{"react":"a1TxN","./shared/src/utils.js":"lfP1m","./Icon.js":"d0fsO","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lfP1m":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasA11yProp", ()=>hasA11yProp);
parcelHelpers.export(exports, "mergeClasses", ()=>mergeClasses);
parcelHelpers.export(exports, "toCamelCase", ()=>toCamelCase);
parcelHelpers.export(exports, "toKebabCase", ()=>toKebabCase);
parcelHelpers.export(exports, "toPascalCase", ()=>toPascalCase);
const toKebabCase = (string)=>string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const toCamelCase = (string)=>string.replace(/^([A-Z])|[\s-_]+(\w)/g, (match, p1, p2)=>p2 ? p2.toUpperCase() : p1.toLowerCase());
const toPascalCase = (string)=>{
    const camelCase = toCamelCase(string);
    return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
};
const mergeClasses = (...classes)=>classes.filter((className, index, array)=>{
        return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
    }).join(" ").trim();
const hasA11yProp = (props)=>{
    for(const prop in props){
        if (prop.startsWith("aria-") || prop === "role" || prop === "title") return true;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"d0fsO":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Icon);
var _react = require("react");
var _defaultAttributesJs = require("./defaultAttributes.js");
var _defaultAttributesJsDefault = parcelHelpers.interopDefault(_defaultAttributesJs);
var _utilsJs = require("./shared/src/utils.js");
const Icon = (0, _react.forwardRef)(({ color = "currentColor", size = 24, strokeWidth = 2, absoluteStrokeWidth, className = "", children, iconNode, ...rest }, ref)=>(0, _react.createElement)("svg", {
        ref,
        ...(0, _defaultAttributesJsDefault.default),
        width: size,
        height: size,
        stroke: color,
        strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
        className: (0, _utilsJs.mergeClasses)("lucide", className),
        ...!children && !(0, _utilsJs.hasA11yProp)(rest) && {
            "aria-hidden": "true"
        },
        ...rest
    }, [
        ...iconNode.map(([tag, attrs])=>(0, _react.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [
            children
        ]
    ]));

},{"react":"a1TxN","./defaultAttributes.js":"9Rm8m","./shared/src/utils.js":"lfP1m","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9Rm8m":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>defaultAttributes);
var defaultAttributes = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"elAlB":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>ChevronRight);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "m9 18 6-6-6-6",
            key: "mthhwq"
        }
    ]
];
const ChevronRight = (0, _createLucideIconJsDefault.default)("chevron-right", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"iKsWV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Calendar", ()=>Calendar);
parcelHelpers.export(exports, "CalendarCell", ()=>CalendarCell);
parcelHelpers.export(exports, "CalendarGrid", ()=>CalendarGrid);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _content = require("./Content");
var _lucideReact = require("lucide-react");
var _button = require("./Button");
var _calendarCss = require("./Calendar.css");
'use client';
function Calendar({ errorMessage, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Calendar), {
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("header", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                        slot: "previous",
                        variant: "quiet",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronLeft), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Heading), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                        slot: "next",
                        variant: "quiet",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronRight), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(CalendarGrid, {
                children: (date)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(CalendarCell, {
                        date: date
                    })
            }),
            errorMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                slot: "errorMessage",
                children: errorMessage
            })
        ]
    });
}
function CalendarCell(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.CalendarCell), {
        ...props,
        className: "react-aria-CalendarCell button-base",
        "data-variant": "quiet"
    });
}
function CalendarGrid(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.CalendarGrid), {
        ...props
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":"2DleA","./Content":"jYtLe","lucide-react":[["ChevronLeft","6gHLa","default"],["ChevronRight","elAlB","default"]],"./Button":"36nan","./Calendar.css":"11b92","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"11b92":[function() {},{}],"bosH7":[function() {},{}],"kWVt3":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>ChevronDown);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "m6 9 6 6 6-6",
            key: "qrunsl"
        }
    ]
];
const ChevronDown = (0, _createLucideIconJsDefault.default)("chevron-down", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"ajx18":[function() {},{}],"4t5bB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateRangePicker", ()=>DateRangePicker);
var _jsxRuntime = require("react/jsx-runtime");
var _lucideReact = require("lucide-react");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _dateField = require("./DateField");
var _dialog = require("./Dialog");
var _field = require("./Field");
var _popover = require("./Popover");
var _rangeCalendar = require("./RangeCalendar");
var _utils = require("./utils");
var _fieldButton = require("./FieldButton");
'use client';
function DateRangePicker({ label, description, errorMessage, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.DateRangePicker), {
        ...props,
        className: (0, _utils.composeTailwindRenderProps)(props.className, 'group flex flex-col gap-1 font-sans'),
        children: [
            label && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Label), {
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _field.FieldGroup), {
                className: "min-w-[208px] w-auto cursor-text disabled:cursor-default",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateField.DateInput), {
                        slot: "start",
                        className: "ps-3 pe-2 text-sm"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        "aria-hidden": "true",
                        className: "text-neutral-800 dark:text-neutral-200 forced-colors:text-[ButtonText] group-disabled:text-neutral-200 dark:group-disabled:text-neutral-600 forced-colors:group-disabled:text-[GrayText]",
                        children: "\u2013"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateField.DateInput), {
                        slot: "end",
                        className: "flex-1 ps-2 pe-3 text-sm"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fieldButton.FieldButton), {
                        className: "w-6 mr-1 outline-offset-0",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.CalendarIcon), {
                            "aria-hidden": true,
                            className: "w-4 h-4"
                        })
                    })
                ]
            }),
            description && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Description), {
                children: description
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldError), {
                children: errorMessage
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popover.Popover), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialog.Dialog), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rangeCalendar.RangeCalendar), {})
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"2Is6Z","lucide-react":[["CalendarIcon","79VlQ","default"]],"react":"a1TxN","react-aria-components":"59rph","./DateField":"bPyay","./Dialog":"cRN3c","./Field":"5fXWs","./Popover":"Dr9D3","./RangeCalendar":"j3lqj","./utils":"jNXji","./FieldButton":"9xJpc","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"79VlQ":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Calendar);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M8 2v4",
            key: "1cmpym"
        }
    ],
    [
        "path",
        {
            d: "M16 2v4",
            key: "4m81vk"
        }
    ],
    [
        "rect",
        {
            width: "18",
            height: "18",
            x: "3",
            y: "4",
            rx: "2",
            key: "1hopcy"
        }
    ],
    [
        "path",
        {
            d: "M3 10h18",
            key: "8toen8"
        }
    ]
];
const Calendar = (0, _createLucideIconJsDefault.default)("calendar", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bPyay":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateField", ()=>DateField);
parcelHelpers.export(exports, "DateInput", ()=>DateInput);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _tailwindVariants = require("tailwind-variants");
var _field = require("./Field");
var _utils = require("./utils");
'use client';
function DateField({ label, description, errorMessage, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.DateField), {
        ...props,
        className: (0, _utils.composeTailwindRenderProps)(props.className, 'flex flex-col gap-1'),
        children: [
            label && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Label), {
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(DateInput, {}),
            description && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.Description), {
                children: description
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldError), {
                children: errorMessage
            })
        ]
    });
}
const segmentStyles = (0, _tailwindVariants.tv)({
    base: 'inline p-0.5 type-literal:p-0 rounded-xs outline outline-0 forced-color-adjust-none caret-transparent text-neutral-800 dark:text-neutral-200 forced-colors:text-[ButtonText]',
    variants: {
        isPlaceholder: {
            true: 'text-neutral-600 dark:text-neutral-400'
        },
        isDisabled: {
            true: 'text-neutral-200 dark:text-neutral-600 forced-colors:text-[GrayText]'
        },
        isFocused: {
            true: 'bg-blue-600 text-white dark:text-white forced-colors:bg-[Highlight] forced-colors:text-[HighlightText]'
        }
    }
});
function DateInput(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.DateInput), {
        className: (renderProps)=>(0, _field.fieldGroupStyles)({
                ...renderProps,
                class: 'inline min-w-[150px] px-3 h-9 text-sm leading-8.5 font-sans cursor-text disabled:cursor-default whitespace-nowrap overflow-x-auto [scrollbar-width:none]'
            }),
        ...props,
        children: (segment)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.DateSegment), {
                segment: segment,
                className: segmentStyles
            })
    });
}

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","react-aria-components":"5wv9P","tailwind-variants":"dpXBU","./Field":"5fXWs","./utils":"jNXji","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5fXWs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Label", ()=>Label);
parcelHelpers.export(exports, "Description", ()=>Description);
parcelHelpers.export(exports, "FieldError", ()=>FieldError);
parcelHelpers.export(exports, "fieldBorderStyles", ()=>fieldBorderStyles);
parcelHelpers.export(exports, "fieldGroupStyles", ()=>fieldGroupStyles);
parcelHelpers.export(exports, "FieldGroup", ()=>FieldGroup);
parcelHelpers.export(exports, "Input", ()=>Input);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _tailwindMerge = require("tailwind-merge");
var _tailwindVariants = require("tailwind-variants");
var _utils = require("./utils");
'use client';
function Label(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Label), {
        ...props,
        className: (0, _tailwindMerge.twMerge)('font-sans text-sm text-neutral-600 dark:text-neutral-300 font-medium cursor-default w-fit', props.className)
    });
}
function Description(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
        ...props,
        slot: "description",
        className: (0, _tailwindMerge.twMerge)('text-sm text-neutral-600', props.className)
    });
}
function FieldError(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.FieldError), {
        ...props,
        className: (0, _utils.composeTailwindRenderProps)(props.className, 'text-sm text-red-600 forced-colors:text-[Mark]')
    });
}
const fieldBorderStyles = (0, _tailwindVariants.tv)({
    base: 'transition',
    variants: {
        isFocusWithin: {
            false: 'border-neutral-300 hover:border-neutral-400 dark:border-neutral-600 dark:hover:border-neutral-500 forced-colors:border-[ButtonBorder]',
            true: 'border-neutral-600 dark:border-neutral-300 forced-colors:border-[Highlight]'
        },
        isInvalid: {
            true: 'border-red-600 dark:border-red-600 forced-colors:border-[Mark]'
        },
        isDisabled: {
            true: 'border-neutral-200 dark:border-neutral-700 forced-colors:border-[GrayText]'
        }
    }
});
const fieldGroupStyles = (0, _tailwindVariants.tv)({
    extend: (0, _utils.focusRing),
    base: 'group flex items-center h-9 box-border bg-white dark:bg-neutral-900 forced-colors:bg-[Field] border rounded-lg overflow-hidden transition',
    variants: fieldBorderStyles.variants
});
function FieldGroup(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Group), {
        ...props,
        className: (0, _reactAriaComponents.composeRenderProps)(props.className, (className, renderProps)=>fieldGroupStyles({
                ...renderProps,
                className
            }))
    });
}
function Input(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Input), {
        ...props,
        className: (0, _utils.composeTailwindRenderProps)(props.className, 'px-3 py-0 min-h-9 flex-1 min-w-0 border-0 outline outline-0 bg-white dark:bg-neutral-900 text-sm text-neutral-800 dark:text-neutral-200 placeholder:text-neutral-600 dark:placeholder:text-neutral-400 disabled:text-neutral-200 dark:disabled:text-neutral-600 disabled:placeholder:text-neutral-200 dark:disabled:placeholder:text-neutral-600')
    });
}

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","react-aria-components":[["composeRenderProps","bA6Cz"],["FieldError","algyu"],["Group","6UspO"],["Input","jU9y1"],["Label","fjKq6"],["Text","jt9fm"]],"tailwind-merge":"lEVAz","tailwind-variants":"dpXBU","./utils":"jNXji","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jNXji":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "focusRing", ()=>focusRing);
parcelHelpers.export(exports, "composeTailwindRenderProps", ()=>composeTailwindRenderProps);
var _reactAriaComponents = require("react-aria-components");
var _tailwindMerge = require("tailwind-merge");
var _tailwindVariants = require("tailwind-variants");
const focusRing = (0, _tailwindVariants.tv)({
    base: 'outline outline-blue-600 dark:outline-blue-500 forced-colors:outline-[Highlight] outline-offset-2',
    variants: {
        isFocusVisible: {
            false: 'outline-0',
            true: 'outline-2'
        }
    }
});
function composeTailwindRenderProps(className, tw) {
    return (0, _reactAriaComponents.composeRenderProps)(className, (className)=>(0, _tailwindMerge.twMerge)(tw, className));
}

},{"react-aria-components":"bA6Cz","tailwind-merge":"lEVAz","tailwind-variants":"dpXBU","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cRN3c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Dialog", ()=>Dialog);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _tailwindMerge = require("tailwind-merge");
'use client';
function Dialog(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Dialog), {
        ...props,
        className: (0, _tailwindMerge.twMerge)('outline outline-0 box-border p-6 [[data-placement]>&]:p-4 max-h-[inherit] overflow-auto relative', props.className)
    });
}

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","react-aria-components":"l2uUY","tailwind-merge":"lEVAz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"Dr9D3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Popover", ()=>Popover);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tailwindVariants = require("tailwind-variants");
'use client';
const styles = (0, _tailwindVariants.tv)({
    base: 'font-sans bg-white dark:bg-neutral-900/70 dark:backdrop-blur-2xl dark:backdrop-saturate-200 forced-colors:bg-[Canvas] shadow-2xl rounded-xl bg-clip-padding border border-black/10 dark:border-white/10 text-neutral-700 dark:text-neutral-300 outline-0',
    variants: {
        isEntering: {
            true: 'animate-in fade-in placement-bottom:slide-in-from-top-1 placement-top:slide-in-from-bottom-1 placement-left:slide-in-from-right-1 placement-right:slide-in-from-left-1 ease-out duration-200'
        },
        isExiting: {
            true: 'animate-out fade-out placement-bottom:slide-out-to-top-1 placement-top:slide-out-to-bottom-1 placement-left:slide-out-to-right-1 placement-right:slide-out-to-left-1 ease-in duration-150'
        }
    }
});
function Popover({ children, showArrow, className, ...props }) {
    let offset = showArrow ? 12 : 8;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Popover), {
        offset: offset,
        ...props,
        className: (0, _reactAriaComponents.composeRenderProps)(className, (className, renderProps)=>styles({
                ...renderProps,
                className
            })),
        children: [
            showArrow && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.OverlayArrow), {
                className: "group",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                    width: 12,
                    height: 12,
                    viewBox: "0 0 12 12",
                    className: "block fill-white dark:fill-[#1f1f21] forced-colors:fill-[Canvas] stroke-1 stroke-black/10 dark:stroke-neutral-700 forced-colors:stroke-[ButtonBorder] group-placement-bottom:rotate-180 group-placement-left:-rotate-90 group-placement-right:rotate-90",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M0 0 L6 6 L12 0"
                    })
                })
            }),
            children
        ]
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["composeRenderProps","bA6Cz"],["OverlayArrow","kMtnS"],["Popover","l4JC0"]],"react":"a1TxN","tailwind-variants":"dpXBU","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"j3lqj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RangeCalendar", ()=>RangeCalendar);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _tailwindVariants = require("tailwind-variants");
var _calendar = require("./Calendar");
var _utils = require("./utils");
'use client';
const cell = (0, _tailwindVariants.tv)({
    extend: (0, _utils.focusRing),
    base: 'w-full h-full flex items-center justify-center rounded-full forced-color-adjust-none text-neutral-900 dark:text-neutral-200',
    variants: {
        selectionState: {
            'none': 'group-hover:bg-neutral-200 dark:group-hover:bg-neutral-700 group-pressed:bg-neutral-300 dark:group-pressed:bg-neutral-600',
            'middle': [
                'group-hover:bg-blue-200 dark:group-hover:bg-blue-900 forced-colors:group-hover:bg-[Highlight]',
                'group-invalid:group-hover:bg-red-200 dark:group-invalid:group-hover:bg-red-900 forced-colors:group-invalid:group-hover:bg-[Mark]',
                'group-pressed:bg-blue-300 dark:group-pressed:bg-blue-800 forced-colors:group-pressed:bg-[Highlight] forced-colors:text-[HighlightText]',
                'group-invalid:group-pressed:bg-red-300 dark:group-invalid:group-pressed:bg-red-800 forced-colors:group-invalid:group-pressed:bg-[Mark]'
            ],
            'cap': 'bg-blue-600 group-invalid:bg-red-600 forced-colors:bg-[Highlight] forced-colors:group-invalid:bg-[Mark] text-white forced-colors:text-[HighlightText]'
        },
        isDisabled: {
            true: 'text-neutral-300 dark:text-neutral-600 forced-colors:text-[GrayText]'
        }
    }
});
function RangeCalendar({ errorMessage, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.RangeCalendar), {
        ...props,
        className: (0, _utils.composeTailwindRenderProps)(props.className, 'font-sans'),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendar.CalendarHeader), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.CalendarGrid), {
                className: "[&_td]:px-0 [&_td]:py-px border-spacing-0",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendar.CalendarGridHeader), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.CalendarGridBody), {
                        children: (date)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.CalendarCell), {
                                date: date,
                                className: "group w-9 h-9 text-sm outline outline-0 cursor-default outside-month:text-neutral-300 selected:bg-blue-100 dark:selected:bg-blue-700/30 forced-colors:selected:bg-[Highlight] invalid:selected:bg-red-100 dark:invalid:selected:bg-red-700/30 forced-colors:invalid:selected:bg-[Mark] [td:first-child_&]:rounded-s-full selection-start:rounded-s-full [td:last-child_&]:rounded-e-full selection-end:rounded-e-full",
                                children: ({ formattedDate, isSelected, isSelectionStart, isSelectionEnd, isFocusVisible, isDisabled })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: cell({
                                            selectionState: isSelected && (isSelectionStart || isSelectionEnd) ? 'cap' : isSelected ? 'middle' : 'none',
                                            isDisabled,
                                            isFocusVisible
                                        }),
                                        children: formattedDate
                                    })
                            })
                    })
                ]
            }),
            errorMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
                slot: "errorMessage",
                className: "text-sm text-red-600",
                children: errorMessage
            })
        ]
    });
}

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","react-aria-components":[["CalendarCell","2DleA"],["CalendarGrid","2DleA"],["CalendarGridBody","2DleA"],["RangeCalendar","2DleA"],["Text","jt9fm"]],"tailwind-variants":"dpXBU","./Calendar":"hFRUB","./utils":"jNXji","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hFRUB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Calendar", ()=>Calendar);
parcelHelpers.export(exports, "CalendarHeader", ()=>CalendarHeader);
parcelHelpers.export(exports, "CalendarGridHeader", ()=>CalendarGridHeader);
var _jsxRuntime = require("react/jsx-runtime");
var _lucideReact = require("lucide-react");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _tailwindVariants = require("tailwind-variants");
var _button = require("./Button");
var _utils = require("./utils");
'use client';
const cellStyles = (0, _tailwindVariants.tv)({
    extend: (0, _utils.focusRing),
    base: 'w-9 h-9 text-sm cursor-default rounded-full flex items-center justify-center forced-color-adjust-none',
    variants: {
        isSelected: {
            false: 'text-neutral-900 dark:text-neutral-200 hover:bg-neutral-200 dark:hover:bg-neutral-700 pressed:bg-neutral-300 dark:pressed:bg-neutral-600',
            true: 'bg-blue-600 invalid:bg-red-600 text-white forced-colors:bg-[Highlight] forced-colors:invalid:bg-[Mark] forced-colors:text-[HighlightText]'
        },
        isDisabled: {
            true: 'text-neutral-300 dark:text-neutral-600 forced-colors:text-[GrayText]'
        }
    }
});
function Calendar({ errorMessage, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Calendar), {
        ...props,
        className: (0, _utils.composeTailwindRenderProps)(props.className, 'flex flex-col font-sans'),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(CalendarHeader, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.CalendarGrid), {
                className: "border-spacing-0",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(CalendarGridHeader, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.CalendarGridBody), {
                        children: (date)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.CalendarCell), {
                                date: date,
                                className: cellStyles
                            })
                    })
                ]
            }),
            errorMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
                slot: "errorMessage",
                className: "text-sm text-red-600",
                children: errorMessage
            })
        ]
    });
}
function CalendarHeader() {
    let { direction } = (0, _reactAriaComponents.useLocale)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("header", {
        className: "flex items-center gap-1 pb-4 px-1 border-box",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                variant: "quiet",
                slot: "previous",
                children: direction === 'rtl' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronRight), {
                    "aria-hidden": true,
                    size: 18
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronLeft), {
                    "aria-hidden": true,
                    size: 18
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Heading), {
                className: "flex-1 font-sans font-semibold [font-variation-settings:normal] text-lg text-center mx-2 text-neutral-900 dark:text-neutral-200"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                variant: "quiet",
                slot: "next",
                children: direction === 'rtl' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronLeft), {
                    "aria-hidden": true,
                    size: 18
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronRight), {
                    "aria-hidden": true,
                    size: 18
                })
            })
        ]
    });
}
function CalendarGridHeader() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.CalendarGridHeader), {
        children: (day)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.CalendarHeaderCell), {
                className: "text-xs text-neutral-500 font-semibold",
                children: day
            })
    });
}

},{"react/jsx-runtime":"2Is6Z","lucide-react":[["ChevronLeft","6gHLa","default"],["ChevronRight","elAlB","default"]],"react":"a1TxN","react-aria-components":[["Calendar","2DleA"],["CalendarCell","2DleA"],["CalendarGrid","2DleA"],["CalendarGridBody","2DleA"],["CalendarGridHeader","2DleA"],["CalendarHeaderCell","2DleA"],["Heading","2f4nH"],["Text","jt9fm"],["useLocale","4k4z8"]],"tailwind-variants":"dpXBU","./Button":"hk9LL","./utils":"jNXji","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hk9LL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Button", ()=>Button);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _tailwindVariants = require("tailwind-variants");
var _utils = require("./utils");
'use client';
let button = (0, _tailwindVariants.tv)({
    extend: (0, _utils.focusRing),
    base: 'relative inline-flex items-center justify-center gap-2 border border-transparent dark:border-white/10 h-9 box-border px-3.5 py-0 [&:has(>svg:only-child)]:px-0 [&:has(>svg:only-child)]:h-8 [&:has(>svg:only-child)]:aspect-square font-sans text-sm text-center transition rounded-lg cursor-default',
    variants: {
        variant: {
            primary: 'bg-blue-600 hover:bg-blue-700 pressed:bg-blue-800 text-white',
            secondary: 'border-black/10 bg-neutral-50 hover:bg-neutral-100 pressed:bg-neutral-200 text-neutral-800 dark:bg-neutral-700 dark:hover:bg-neutral-600 dark:pressed:bg-neutral-500 dark:text-neutral-100',
            destructive: 'bg-red-700 hover:bg-red-800 pressed:bg-red-900 text-white',
            quiet: 'border-0 bg-transparent hover:bg-neutral-200 pressed:bg-neutral-300 text-neutral-800 dark:hover:bg-neutral-700 dark:pressed:bg-neutral-600 dark:text-neutral-100'
        },
        isDisabled: {
            true: 'border-transparent dark:border-transparent bg-neutral-100 dark:bg-neutral-800 text-neutral-300 dark:text-neutral-600 forced-colors:text-[GrayText]'
        },
        isPending: {
            true: 'text-transparent'
        }
    },
    defaultVariants: {
        variant: 'primary'
    },
    compoundVariants: [
        {
            variant: 'quiet',
            isDisabled: true,
            class: 'bg-transparent dark:bg-transparent'
        }
    ]
});
function Button(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
        ...props,
        className: (0, _reactAriaComponents.composeRenderProps)(props.className, (className, renderProps)=>button({
                ...renderProps,
                variant: props.variant,
                className
            })),
        children: (0, _reactAriaComponents.composeRenderProps)(props.children, (children, { isPending })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    children,
                    isPending && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        "aria-hidden": true,
                        className: "flex absolute inset-0 justify-center items-center",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                            className: "w-4 h-4 text-white animate-spin",
                            viewBox: "0 0 24 24",
                            stroke: props.variant === 'secondary' || props.variant === 'quiet' ? 'light-dark(black, white)' : 'white',
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                    cx: "12",
                                    cy: "12",
                                    r: "10",
                                    strokeWidth: "4",
                                    fill: "none",
                                    className: "opacity-25"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                    cx: "12",
                                    cy: "12",
                                    r: "10",
                                    strokeWidth: "4",
                                    strokeLinecap: "round",
                                    fill: "none",
                                    pathLength: "100",
                                    strokeDasharray: "60 140",
                                    strokeDashoffset: "0"
                                })
                            ]
                        })
                    })
                ]
            }))
    });
}

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","react-aria-components":[["Button","9G5XO"],["composeRenderProps","bA6Cz"]],"tailwind-variants":"dpXBU","./utils":"jNXji","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9xJpc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FieldButton", ()=>FieldButton);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaComponents = require("react-aria-components");
var _tailwindVariants = require("tailwind-variants");
var _utils = require("./utils");
'use client';
let button = (0, _tailwindVariants.tv)({
    extend: (0, _utils.focusRing),
    base: 'relative inline-flex items-center border-0 font-sans text-sm text-center transition rounded-md cursor-default p-1 flex items-center justify-center text-neutral-600 bg-transparent hover:bg-black/[5%] pressed:bg-black/10 dark:text-neutral-400 dark:hover:bg-white/10 dark:pressed:bg-white/20 disabled:bg-transparent',
    variants: {
        isDisabled: {
            true: 'bg-neutral-100 dark:bg-neutral-800 text-neutral-300 dark:text-neutral-600 forced-colors:text-[GrayText] border-black/5 dark:border-white/5'
        }
    }
});
function FieldButton(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
        ...props,
        className: (0, _reactAriaComponents.composeRenderProps)(props.className, (className, renderProps)=>button({
                ...renderProps,
                className
            })),
        children: props.children
    });
}

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","react-aria-components":[["Button","9G5XO"],["composeRenderProps","bA6Cz"]],"tailwind-variants":"dpXBU","./utils":"jNXji","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"ajUmr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _date = require("@internationalized/date");
var _reactAria = require("react-aria");
var _dateRangePicker = require("vanilla-starter/DateRangePicker");
var _react = require("react");
"use client";
function Example() {
    let [range, setRange] = (0, _react.useState)({
        start: (0, _date.parseDate)('2025-02-03'),
        end: (0, _date.parseDate)('2025-02-12')
    });
    let formatter = (0, _reactAria.useDateFormatter)({
        dateStyle: 'long'
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateRangePicker.DateRangePicker), {
                value: range,
                onChange: setRange
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    "Selected range: ",
                    formatter.formatRange(range.start.toDate((0, _date.getLocalTimeZone)()), range.end.toDate((0, _date.getLocalTimeZone)()))
                ]
            })
        ]
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)(Example, {});

},{"react/jsx-runtime":"2Is6Z","@internationalized/date":[["getLocalTimeZone","1rmIt"],["parseDate","4CWCl"]],"react-aria":"l0ABP","vanilla-starter/DateRangePicker":"hdd3W","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"l0ABP":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides localized date formatting for the current locale. Automatically updates when the locale changes,
 * and handles caching of the date formatter for performance.
 * @param options - Formatting options.
 */ parcelHelpers.export(exports, "useDateFormatter", ()=>useDateFormatter);
var _date = require("@internationalized/date");
var _utils = require("@react-aria/utils");
var _context = require("./context");
var _react = require("react");
function useDateFormatter(options) {
    // Reuse last options object if it is shallowly equal, which allows the useMemo result to also be reused.
    options = (0, _utils.useDeepMemo)(options ?? {}, isEqual);
    let { locale } = (0, _context.useLocale)();
    return (0, _react.useMemo)(()=>new (0, _date.DateFormatter)(locale, options), [
        locale,
        options
    ]);
}
function isEqual(a, b) {
    if (a === b) return true;
    let aKeys = Object.keys(a);
    let bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return false;
    for (let key of aKeys){
        if (b[key] !== a[key]) return false;
    }
    return true;
}

},{"@internationalized/date":"6ueXY","@react-aria/utils":"6otos","./context":"4k4z8","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6ueXY":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** A wrapper around Intl.DateTimeFormat that fixes various browser bugs, and polyfills new features. */ parcelHelpers.export(exports, "DateFormatter", ()=>DateFormatter);
let formatterCache = new Map();
class DateFormatter {
    constructor(locale, options = {}){
        this.formatter = getCachedDateFormatter(locale, options);
        this.options = options;
    }
    /** Formats a date as a string according to the locale and format options passed to the constructor. */ format(value) {
        return this.formatter.format(value);
    }
    /** Formats a date to an array of parts such as separators, numbers, punctuation, and more. */ formatToParts(value) {
        return this.formatter.formatToParts(value);
    }
    /** Formats a date range as a string. */ formatRange(start, end) {
        // @ts-ignore
        if (typeof this.formatter.formatRange === 'function') // @ts-ignore
        return this.formatter.formatRange(start, end);
        if (end < start) throw new RangeError('End date must be >= start date');
        // Very basic fallback for old browsers.
        return `${this.formatter.format(start)} \u{2013} ${this.formatter.format(end)}`;
    }
    /** Formats a date range as an array of parts. */ formatRangeToParts(start, end) {
        // @ts-ignore
        if (typeof this.formatter.formatRangeToParts === 'function') // @ts-ignore
        return this.formatter.formatRangeToParts(start, end);
        if (end < start) throw new RangeError('End date must be >= start date');
        let startParts = this.formatter.formatToParts(start);
        let endParts = this.formatter.formatToParts(end);
        return [
            ...startParts.map((p)=>({
                    ...p,
                    source: 'startRange'
                })),
            {
                type: 'literal',
                value: " \u2013 ",
                source: 'shared'
            },
            ...endParts.map((p)=>({
                    ...p,
                    source: 'endRange'
                }))
        ];
    }
    /** Returns the resolved formatting options based on the values passed to the constructor. */ resolvedOptions() {
        let resolvedOptions = this.formatter.resolvedOptions();
        if (hasBuggyResolvedHourCycle()) {
            if (!this.resolvedHourCycle) this.resolvedHourCycle = getResolvedHourCycle(resolvedOptions.locale, this.options);
            resolvedOptions.hourCycle = this.resolvedHourCycle;
            resolvedOptions.hour12 = this.resolvedHourCycle === 'h11' || this.resolvedHourCycle === 'h12';
        }
        // Safari uses a different name for the Ethiopic (Amete Alem) calendar.
        // https://bugs.webkit.org/show_bug.cgi?id=241564
        if (resolvedOptions.calendar === 'ethiopic-amete-alem') resolvedOptions.calendar = 'ethioaa';
        return resolvedOptions;
    }
}
// There are multiple bugs involving the hour12 and hourCycle options in various browser engines.
//   - Chrome [1] (and the ECMA 402 spec [2]) resolve hour12: false in English and other locales to h24 (24:00 - 23:59)
//     rather than h23 (00:00 - 23:59). Same can happen with hour12: true in French, which Chrome resolves to h11 (00:00 - 11:59)
//     rather than h12 (12:00 - 11:59).
//   - WebKit returns an incorrect hourCycle resolved option in the French locale due to incorrect parsing of 'h' literal
//     in the resolved pattern. It also formats incorrectly when specifying the hourCycle option for the same reason. [3]
// [1] https://bugs.chromium.org/p/chromium/issues/detail?id=1045791
// [2] https://github.com/tc39/ecma402/issues/402
// [3] https://bugs.webkit.org/show_bug.cgi?id=229313
// https://github.com/unicode-org/cldr/blob/018b55eff7ceb389c7e3fc44e2f657eae3b10b38/common/supplemental/supplementalData.xml#L4774-L4802
const hour12Preferences = {
    true: {
        // Only Japanese uses the h11 style for 12 hour time. All others use h12.
        ja: 'h11'
    },
    false: {
    }
};
function getCachedDateFormatter(locale, options = {}) {
    // Work around buggy hour12 behavior in Chrome / ECMA 402 spec by using hourCycle instead.
    // Only apply the workaround if the issue is detected, because the hourCycle option is buggy in Safari.
    if (typeof options.hour12 === 'boolean' && hasBuggyHour12Behavior()) {
        options = {
            ...options
        };
        let pref = hour12Preferences[String(options.hour12)][locale.split('-')[0]];
        let defaultHourCycle = options.hour12 ? 'h12' : 'h23';
        options.hourCycle = pref ?? defaultHourCycle;
        delete options.hour12;
    }
    let cacheKey = locale + (options ? Object.entries(options).sort((a, b)=>a[0] < b[0] ? -1 : 1).join() : '');
    if (formatterCache.has(cacheKey)) return formatterCache.get(cacheKey);
    let numberFormatter = new Intl.DateTimeFormat(locale, options);
    formatterCache.set(cacheKey, numberFormatter);
    return numberFormatter;
}
let _hasBuggyHour12Behavior = null;
function hasBuggyHour12Behavior() {
    if (_hasBuggyHour12Behavior == null) _hasBuggyHour12Behavior = new Intl.DateTimeFormat('en-US', {
        hour: 'numeric',
        hour12: false
    }).format(new Date(2020, 2, 3, 0)) === '24';
    return _hasBuggyHour12Behavior;
}
let _hasBuggyResolvedHourCycle = null;
function hasBuggyResolvedHourCycle() {
    if (_hasBuggyResolvedHourCycle == null) _hasBuggyResolvedHourCycle = new Intl.DateTimeFormat('fr', {
        hour: 'numeric',
        hour12: false
    }).resolvedOptions().hourCycle === 'h12';
    return _hasBuggyResolvedHourCycle;
}
function getResolvedHourCycle(locale, options) {
    if (!options.timeStyle && !options.hour) return undefined;
    // Work around buggy results in resolved hourCycle and hour12 options in WebKit.
    // Format the minimum possible hour and maximum possible hour in a day and parse the results.
    locale = locale.replace(/(-u-)?-nu-[a-zA-Z0-9]+/, '');
    locale += (locale.includes('-u-') ? '' : '-u') + '-nu-latn';
    let formatter = getCachedDateFormatter(locale, {
        ...options,
        timeZone: undefined // use local timezone
    });
    let min = parseInt(formatter.formatToParts(new Date(2020, 2, 3, 0)).find((p)=>p.type === 'hour').value, 10);
    let max = parseInt(formatter.formatToParts(new Date(2020, 2, 3, 23)).find((p)=>p.type === 'hour').value, 10);
    if (min === 0 && max === 23) return 'h23';
    if (min === 24 && max === 23) return 'h24';
    if (min === 0 && max === 11) return 'h11';
    if (min === 12 && max === 11) return 'h12';
    throw new Error('Unexpected hour cycle result');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6otos":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /* eslint-disable rulesdir/pure-render */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDeepMemo", ()=>useDeepMemo);
var _react = require("react");
function useDeepMemo(value, isEqual) {
    // Using a ref during render is ok here because it's only an optimization – both values are equivalent.
    // If a render is thrown away, it'll still work the same no matter if the next render is the same or not.
    let lastValue = (0, _react.useRef)(null);
    if (value && lastValue.current && isEqual(value, lastValue.current)) value = lastValue.current;
    lastValue.current = value;
    return value;
}

},{"react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3uKbE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _date = require("@internationalized/date");
var _dateRangePicker = require("vanilla-starter/DateRangePicker");
"use client";
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateRangePicker.DateRangePicker), {
    defaultValue: {
        start: (0, _date.parseZonedDateTime)('2025-02-03T08:45:00[America/Los_Angeles]'),
        end: (0, _date.parseZonedDateTime)('2025-02-14T08:45:00[America/Los_Angeles]')
    }
});

},{"react/jsx-runtime":"2Is6Z","@internationalized/date":"4CWCl","vanilla-starter/DateRangePicker":"hdd3W","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"11V6i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _date = require("@internationalized/date");
var _dateRangePicker = require("vanilla-starter/DateRangePicker");
"use client";
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.I18nProvider), {
    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateRangePicker.DateRangePicker), {
        defaultValue: {
            start: (0, _date.parseDate)('2025-02-03'),
            end: (0, _date.parseDate)('2025-02-14')
        }
    })
});

},{"react/jsx-runtime":"2Is6Z","react-aria-components":"4k4z8","@internationalized/date":"4CWCl","vanilla-starter/DateRangePicker":"hdd3W","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1Jq62":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _date = require("@internationalized/date");
var _reactAria = require("react-aria");
var _dateRangePicker = require("vanilla-starter/DateRangePicker");
var _button = require("vanilla-starter/Button");
var _form = require("vanilla-starter/Form");
"use client";
function Example(props) {
    let { locale } = (0, _reactAria.useLocale)();
    let now = (0, _date.today)((0, _date.getLocalTimeZone)());
    let disabledRanges = [
        [
            now,
            now.add({
                days: 5
            })
        ],
        [
            now.add({
                days: 14
            }),
            now.add({
                days: 16
            })
        ],
        [
            now.add({
                days: 23
            }),
            now.add({
                days: 24
            })
        ]
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Form), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateRangePicker.DateRangePicker), {
                ...props,
                label: "Trip dates",
                startName: "startDate",
                endName: "endDate",
                isRequired: true,
                minValue: (0, _date.today)((0, _date.getLocalTimeZone)()),
                isDateUnavailable: (date)=>(0, _date.isWeekend)(date, locale) || disabledRanges.some((interval)=>date.compare(interval[0]) >= 0 && date.compare(interval[1]) <= 0)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                type: "submit",
                children: "Submit"
            })
        ]
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)(Example, {});

},{"react/jsx-runtime":"2Is6Z","@internationalized/date":"1rmIt","react-aria":"4k4z8","vanilla-starter/DateRangePicker":"hdd3W","vanilla-starter/Button":"36nan","vanilla-starter/Form":"6qejZ","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2370J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M13 2.5H7c-.414 0-.75-.336-.75-.75S6.586 1 7 1h6c.414 0 .75.336.75.75s-.336.75-.75.75M16.773 14.48q-.022-.046-.05-.09L12.49 7.78V5.493h.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-1.25c-.414 0-.75.336-.75.75V8c0 .144.041.284.119.404l1.171 1.83-5.686 1.743 2.279-3.574c.076-.12.117-.26.117-.403V4.743c0-.414-.336-.75-.75-.75H6.99c-.414 0-.75.336-.75.75s.336.75.75.75h.5v2.288l-4.213 6.61q-.028.043-.049.09c-.351.761-.29 1.638.164 2.346C3.86 17.562 4.67 18 5.558 18h8.884c.887 0 1.697-.438 2.167-1.173.453-.708.515-1.585.164-2.347m-1.427 1.539c-.193.301-.531.481-.904.481H5.558c-.373 0-.71-.18-.904-.481-.171-.268-.2-.582-.082-.87l.779-1.222 7.768-2.383 2.31 3.604c.117.29.088.604-.083.87"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kmqkh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M7.75 16.465c-.187 0-.374-.07-.52-.21-.298-.287-.308-.762-.02-1.06l4.999-5.197-4.986-5.184c-.288-.297-.279-.772.02-1.06.296-.286.774-.278 1.06.021L13.79 9.48c.28.29.28.749 0 1.039l-5.5 5.716c-.146.154-.344.23-.54.23"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bneuv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M16.25 14H3.75c-.414 0-.75.336-.75.75s.336.75.75.75h12.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75M3.75 5.5h12.5c.414 0 .75-.336.75-.75S16.664 4 16.25 4H3.75c-.414 0-.75.336-.75.75s.336.75.75.75M16.25 9H3.75c-.414 0-.75.336-.75.75s.336.75.75.75h12.5c.414 0 .75-.336.75-.75S16.664 9 16.25 9"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}]},[], null, "parcelRequire7f0c", {})

//# sourceMappingURL=DateRangePicker.6564c82e.js.map
